// AdminChatPage
import React from 'react';

import CallsHub from '../../pages/CallsHub';

const AdminChatPage = () => {
    return <CallsHub />;
};

export default AdminChatPage;